export default "__VITE_ASSET__UtawJXPb__"